import moment from "moment";
import { isCurrentOrFuture, isFuture, isPast, isPastOrCurrent } from "../../../utilities/DateUtility";
import { GuestReservationVerificationResultStatus, LegacyReservationStatus } from "./ReservationDetailConstants";
import { ReservationStatus } from "../models/ReservationStatus";
import { ReservationSearchRecord } from "../models/ReservationSearchRecord";
import { ColorPropType, ColorProp, getColor } from "../../../layout/Colors";
import { Reservation } from "../models/Reservation";

export const getVerificationStatusPillColor = (status?: string): string => {
  let verificationStatusColorProp: ColorPropType = ColorProp.GuestDefault;
  
  switch (status) {
    case GuestReservationVerificationResultStatus.PROCESSING:
      verificationStatusColorProp = ColorProp.GuestProcessing;
      break;
    case GuestReservationVerificationResultStatus.CAUTION:
      verificationStatusColorProp = ColorProp.GuestConsider;
      break;
    case GuestReservationVerificationResultStatus.ERROR:
      verificationStatusColorProp = ColorProp.GuestDefault;
      break;
    case GuestReservationVerificationResultStatus.NO_VERIFICATION:
      verificationStatusColorProp = ColorProp.GuestDefault;
      break;
    case GuestReservationVerificationResultStatus.PASSED:
      verificationStatusColorProp = ColorProp.GuestSuccess;
      break;
    default:
      verificationStatusColorProp = ColorProp.GuestDefault;
  }

  return getColor(verificationStatusColorProp);
}

export const getReservationStatusPillColor = (status: LegacyReservationStatus): string => {
  let statusStr = 'UPCOMING';
  switch(status) {
    case LegacyReservationStatus.UPCOMING:
      statusStr = 'UPCOMING';
      break;
    case LegacyReservationStatus.IN_HOME:
      statusStr = 'IN HOME';
      break;
    case LegacyReservationStatus.COMPLETE:
      statusStr = 'COMPLETE';
      break;
    case LegacyReservationStatus.CLAIM_FILED:
      statusStr = 'CLAIM FILED';
      break;
    case LegacyReservationStatus.CANCELED:
      statusStr = 'CANCELED';
      break;
  }

  return getReservationStatusColor(statusStr);
}

export const getReservationStatusColor = (status: string): string => {
  let reservationStatusColorProp: ColorPropType = ColorProp.ReservationStatusDefault;

  switch(status.toUpperCase()) {
    case 'UPCOMING':
      reservationStatusColorProp = ColorProp.ReservationStatusUpcoming;
      break;
    case 'IN HOME':
      reservationStatusColorProp = ColorProp.ReservationStatusInHome;
      break;
    case 'COMPLETE':
      reservationStatusColorProp = ColorProp.ReservationStatusComplete;
      break;
    case 'CLAIM FILED':
      reservationStatusColorProp = ColorProp.ReservationStatusClaimFiled;
      break;
    case 'CANCELED':
      reservationStatusColorProp = ColorProp.ReservationStatusCanceled;
      break;
  }

  return getColor(reservationStatusColorProp);
}
 
export const getLegacyReservationStatus = (reservation: Reservation): LegacyReservationStatus => {
  let status = LegacyReservationStatus.INVALID;

  const arrivalDate = reservation.arrival_date;
  const departureDate = reservation.departure_date;

  if (reservation.status_id === 3) {
    status = LegacyReservationStatus.CANCELED;
  } else if(reservation.claim_count > 0) {
    status = LegacyReservationStatus.CLAIM_FILED;
  } else if(arrivalDate && isFuture(arrivalDate)) {
    status = LegacyReservationStatus.UPCOMING;
  } else if(arrivalDate !== null && departureDate !== null && isPastOrCurrent(arrivalDate) && isCurrentOrFuture(departureDate)) {
    status = LegacyReservationStatus.IN_HOME;
  } else if(isPast(departureDate) ) {
    status = LegacyReservationStatus.COMPLETE;
  }

  return status;
}

export const getReservationStatus = (reservation: ReservationSearchRecord): ReservationStatus | undefined => {
  let status;

  const arrivalDate = reservation.arrivalDate;
  const departureDate = reservation.departureDate;

  if(reservation.statusId == 3) {
    status = ReservationStatus.CANCELED;
  } else if(reservation.claimCount > 0) {
    status = ReservationStatus.CLAIM_FILED;
  } else if(arrivalDate && isFuture(arrivalDate)) {
    status = ReservationStatus.UPCOMING;
  } else if(arrivalDate !== null && departureDate !== null && isPastOrCurrent(arrivalDate) && isCurrentOrFuture(departureDate)) {
    status = ReservationStatus.IN_HOME;
  } else if(isPast(departureDate)) {
    status = ReservationStatus.COMPLETE;
  }

  return status;
}

export const getFormattedReservationStatus = (reservation: Reservation): string => {
  let status = getLegacyReservationStatus(reservation);
  return status != null ? LegacyReservationStatus[status].split('_').join(' ') : '';
}

export const canFileClaimForReservation = (departureDate: string, status: ReservationStatus, naUser: boolean): boolean => {
  const reservationComplete = status == ReservationStatus.COMPLETE;
  const guestIsInHome = status == ReservationStatus.IN_HOME;
  const claimAlreadyFiled = status == ReservationStatus.CLAIM_FILED;
  const reservationStatusAllowsNewClaim = reservationComplete || guestIsInHome || claimAlreadyFiled;

  if (!naUser) {
    return reservationStatusAllowsNewClaim;
  }

  return reservationStatusAllowsNewClaim;
}

export const hasBeenLessThanOrEqualTo60DaysSinceGuestDeparture = (departureDate: string): boolean => {
  if(!departureDate) {
    return false;
  }

  const departureDateMoment = moment(departureDate);
  return moment().diff(departureDateMoment, 'days') <= 60;
}